const TENANT_CUSTOM_CSS_ID = 'tenant-custom-css';

export function applyTenantCustomCss(customCss?: string | null): void {
  const css = customCss?.trim();
  const existingStyle = document.getElementById(TENANT_CUSTOM_CSS_ID);

  if (!css) {
    existingStyle?.remove();
    return;
  }

  const style =
    existingStyle instanceof HTMLStyleElement
      ? existingStyle
      : document.createElement('style');

  style.id = TENANT_CUSTOM_CSS_ID;
  style.textContent = css;

  if (!existingStyle) {
    document.head.appendChild(style);
  }
}
